import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import {
  areaResponse,
  dongResponse,
  errorResponse,
  hoResponse,
  successResponse,
  residentResponse,
  residentWithMetaResponse,
  bootResponse,
} from "./types/response";
import { filteredApiProps, userApiProps } from "./types/props";

const axiosConfig: AxiosRequestConfig = {
  baseURL: "/comExec/api/index.php?api_path=",
  headers: {
    accept: "application/json",
  },
};

const axiosInstance = axios.create(axiosConfig);

export const aptInfoApi = {
  getInfo: async () => {
    return await axiosInstance({
      url: `/apt/boot?host=${window.location.host}`,
    })
      .then((res: AxiosResponse<bootResponse>) => res.data)
      .catch((err) => err);
  },

  getDong: async (apt_id: string) => {
    return await axiosInstance({
      url: `/apt/buildings?apt_id=${apt_id}`,
    })
      .then((res: AxiosResponse<dongResponse>) => res.data)
      .catch((err) => err);
  },

  getHo: async (apt_id: string, dong: string) => {
    return await axiosInstance({
      url: `/apt/units?apt_id=${apt_id}&dong=${dong}`,
    })
      .then((res: AxiosResponse<hoResponse>) => res.data)
      .catch((err) => err);
  },

  getArea: async (apt_id: string) => {
    return await axiosInstance({
      url: `/apt/area?apt_id=${apt_id}`,
    })
      .then((res: AxiosResponse<areaResponse>) => res.data)
      .catch((err) => err);
  },
};

export const residentApi = {
  get: async () => {
    return await axiosInstance({
      url: "/apt/resident",
    })
      .then((res: AxiosResponse<residentResponse>) => res.data)
      .catch((err) => err);
  },

  getFiltered: async ({
    page,
    dong,
    ho,
    area_code,
    search_text,
  }: filteredApiProps) => {
    return await axiosInstance({
      url: `/apt/resident?${dong ? `dong=${dong}` : ""}${
        ho ? `&ho=${ho}` : ""
      }${area_code ? `&area_code=${area_code}` : ""}${
        page !== undefined ? `&page=${page}&size=100` : ""
      }${search_text ? `&search_text=${search_text}` : ""}`,
    })
      .then((res: AxiosResponse<residentWithMetaResponse>) => res.data)
      .catch((err) => err);
  },

  register: async (data: userApiProps) => {
    return await axiosInstance({
      method: "POST",
      url: "/apt/resident",
      data,
    })
      .then((res: AxiosResponse<successResponse>) => res.data)
      .catch((err) => err);
  },

  modify: async (id: number, data: userApiProps) => {
    return await axiosInstance({
      method: "PUT",
      url: `/apt/resident/${id}`,
      data,
    })
      .then((res: AxiosResponse<successResponse>) => res.data)
      .catch((err) => err);
  },

  remove: async (ids: number[]) => {
    return await axiosInstance({
      method: "DELETE",
      url: `/apt/resident/many`,
      data: {
        ids,
      },
    })
      .then((res: AxiosResponse<successResponse>) => res.data)
      .catch((err) => err);
  },

  registerWithExcel: async (data: any) => {
    return await axiosInstance({
      method: "POST",
      url: "/apt/resident/many",
      data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res: AxiosResponse<successResponse>) => res.data)
      .catch((err) => err);
  },

  getTemplate: async () => {
    return await axiosInstance({
      url: "/apt/resident/template",
      responseType: "blob",
    })
      .then((res) => res.data)
      .catch((err) => err);
  },
};
